import { ICreateParcelModel } from "../i-create-parcel-model"

export class CreateParcelModelExtension {
    readonly name: string
    enabled: boolean = false
    _value: boolean = false
    visible: boolean

    get value(): boolean {
        return this._value
    }

    set value(value: boolean) {
        this._value = value
        this.createParcelModel.consolidateVariantFromContext(this)
    }

    private readonly createParcelModel: ICreateParcelModel

    constructor(createParcelModel: ICreateParcelModel, name: string, visible: boolean = true) {
        this.createParcelModel = createParcelModel
        this.name = name
        this.visible = visible
    }
}
